import { Component, Input } from '@angular/core';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { AmandaOptions, AssetsSharedService } from 'shared/services/assets-shared.service';

import { CloseSectionType, SliceFlexSettings } from 'extensions/core/slice-flex/front/slice-flex-settings.model';

import { templateUrl, styleUrls } from './slice-flex-close.component.paths';


@Component({
  selector: 'slice-flex-close',
  templateUrl,
  styleUrls
})
export class SliceFlexCloseComponent {

  @Input() public settings!: SliceFlexSettings;

  constructor(
    protected readonly renderConfigurationService: RenderConfigurationService,
    private readonly assetsSharedService: AssetsSharedService
  ) {}

  public get closeSectionType(): CloseSectionType {
    return this.settings.general.closeSectionType ?? 'icon';
  }

  public get closeSectionText(): string {
    return this.settings.general.closeSectionText ?? '';
  }

  public get closeSectionCustomImage(): string | undefined {
    const assetsUrl = this.renderConfigurationService.config.assetsUrl;
    const akamaiOptions: AmandaOptions = { isWidthParamEnabled: false };
    const image = this.settings.general.closeSectionCustomImage?.image ?? undefined;

    return this.assetsSharedService.getAssetUrl(image, assetsUrl, akamaiOptions);
  }

}
